import {Event} from "@app/core/tracking/domain/event";
import {AppOpenedWithProductsInCartEvent} from "@app/core/tracking/application/events/app-opened-with-products-in-cart-event";
import {AdobeExperiencePlatformService} from "@app/core/tracking/infrastructure/adobe-experience-platform-service";
import {Injectable} from "@angular/core";
import {UsualPurchaseViewedEvent} from "@app/core/tracking/application/events/usual-purchase-viewed-event";
import {ListsViewedEvent} from "@app/core/tracking/application/events/lists-viewed-event";
import { CouponsViewedEvent } from "@app/core/tracking/application/events/coupons-viewed-event";
import { CheckoutViewedEvent } from "@app/core/tracking/application/events/checkout-viewed-event";
import { OrderCompletedEvent } from "@app/core/tracking/application/events/order-completed-event";
import {UserWentIdleEvent} from "@app/core/tracking/application/events/user-went-idle-event";
import {HomeScrolledEvent} from "@app/core/tracking/application/events/home-scrolled-event";
import {CatalogScrolledEvent} from "@app/core/tracking/application/events/catalog-scrolled-event";

/**
 * Service responsible for managing and notifying events within the application,
 * specifically for Adobe Experience Platform (Adobe Campaign).
 */
@Injectable({
    providedIn: 'root'
})
export class AdobeEventService {

    private static eventToTrackActionNameMap = new Map<Event, string>([
        [AppOpenedWithProductsInCartEvent, 'app_opened_with_products_in_cart'],
        [ListsViewedEvent, 'lists_viewed'],
        [CouponsViewedEvent, 'coupons_viewed'],
        [CheckoutViewedEvent, 'checkout_viewed'],
        [UsualPurchaseViewedEvent, 'usual_purchase_viewed'],
        [OrderCompletedEvent, 'order_completed'],
        [UserWentIdleEvent, 'user_went_idle'],
        [HomeScrolledEvent, 'home_scrolled'],
        [CatalogScrolledEvent, 'catalog_scrolled']
    ]);

    constructor(
        private  adobeExperiencePlatformService: AdobeExperiencePlatformService
    ) {}

    notify(event: Event): void {
        const trackActionName = this.mapEventToTrackActionName(event);
        // If the track action name is null, means that the event is not supported.
        if (trackActionName == null) {
            return;
        }
        this.adobeExperiencePlatformService.trackAction(trackActionName);
    }

    /**
     * Maps the given event to a track action name.
     * @param event - The event to map.
     * @returns The track action name, or null if the event is not supported.
     */
    private mapEventToTrackActionName(event: Event): string | null {
        return AdobeEventService.eventToTrackActionNameMap.get(event.constructor) ?? null;
    }
}